import { createContext } from 'react';

export const CounterRatiosContext = createContext();